import { CircularProgress } from '@mui/material';

import styles from './Loader.module.scss';

const Loader = () => {
  return (
    <div className={styles.container}>
      <CircularProgress thickness={4} />
    </div>
  );
};

export default Loader;
